import { UploadOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const UploadExcelBtn = ({ ...rest }) => {
  return (
    <Button
      color="primary"
      variant="outlined"
      icon={<UploadOutlined />}
      {...rest}
    >
      Importar archivo
    </Button>
  );
};
